// Empty string -> relative paths, i.e. same-origin (production, reverse-proxied
// through the site's own domain). Local dev overrides this via .env, since the
// dev frontend (localhost:3000) and API (localhost:4000) run on different ports.
const API_URL = process.env.REACT_APP_API_URL || '';

export async function searchSite(query, {signal} = {}) {
    const res = await fetch(`${API_URL}/api/search?q=${encodeURIComponent(query)}`, {signal});
    if (!res.ok) {
        throw new Error(`Search request failed with status ${res.status}`);
    }
    return res.json();
}
